import type {FiltersBarItem} from '@macmillanplatform/ui-core/types';

import {
  NOT_HIDABLE_COLUMNS,
  ORDERS_COLUMN_STYLES,
  ORDERS_DETAILS_URL_PARAMS,
  ORDERS_DETAILS_URL_PARAMS_PREFIX,
  ORDERS_FROZEN_COLUMNS,
  ORDERS_URL_PARAMS,
} from '../../../constants';

import {getUrlParamsValues} from '../../../helpers/url-params';
import {readAuthData} from '@/features/auth/helpers';
import {browserHistory} from '@/shared/utils';

export const getStateFromUrl = () => {
  const local = readAuthData();

  const shippingStatus = browserHistory.getParameterValue(
    ORDERS_DETAILS_URL_PARAMS.SHIPPING_STATUS,
    ''
  );
  const shippingStatusArray = shippingStatus
    ? shippingStatus.trim().split(',').filter(Boolean)
    : [];

  const poStatus = browserHistory.getParameterValue(
    ORDERS_DETAILS_URL_PARAMS.PO_STATUS,
    ''
  );
  const poStatusArray = poStatus
    ? poStatus.trim().split(',').filter(Boolean)
    : [];

  const orderDetailsValues = getUrlParamsValues(
    `${ORDERS_DETAILS_URL_PARAMS_PREFIX}_`,
    local?.order_details?.limit || 5
  );

  const searchStates = {
    orders: getUrlParamsValues(),
    order_details: {
      [ORDERS_DETAILS_URL_PARAMS.LIMIT]: orderDetailsValues.limit,
      [ORDERS_DETAILS_URL_PARAMS.OFFSET]: orderDetailsValues.offset,
    },
  };

  return {
    filtersValues: {
      [ORDERS_URL_PARAMS.SEARCH]: browserHistory
        .getParameterValue(ORDERS_URL_PARAMS.SEARCH, '')
        .trim(),
    },
    [ORDERS_DETAILS_URL_PARAMS.FILTERS]: {
      [ORDERS_DETAILS_URL_PARAMS.SHIPPING_STATUS]: shippingStatusArray,
      [ORDERS_DETAILS_URL_PARAMS.PO_STATUS]: poStatusArray,
      [ORDERS_DETAILS_URL_PARAMS.SEARCH]: browserHistory.getParameterValue(
        ORDERS_DETAILS_URL_PARAMS.SEARCH,
        ''
      ),
    },
    searchPageValues: searchStates.orders,
    searchStates,
  };
};

export const generateGridProps = () => {
  return {
    gridStyles: {width: '100%'},
    columnStyles: ORDERS_COLUMN_STYLES,
    frozenColumns: ORDERS_FROZEN_COLUMNS,
    notHidableColumns: NOT_HIDABLE_COLUMNS,
  };
};

const handleSearch = (q: string, paramName: string) => {
  const offsetParamName = paramName.includes(ORDERS_DETAILS_URL_PARAMS_PREFIX)
    ? ORDERS_DETAILS_URL_PARAMS.OFFSET
    : ORDERS_URL_PARAMS.OFFSET;

  browserHistory.setParametersValues([
    {name: paramName, value: q},
    {name: offsetParamName, value: 0},
  ]);
};

const onSearchEnterPress =
  (paramName: string) => (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') handleSearch(e.currentTarget.value, paramName);
  };

export const getSearchField = ({
  name,
  placeholder,
  className,
  customKey,
  clearable = false,
}): FiltersBarItem => ({
  type: 'search',
  name,
  key: customKey,
  props: {
    onSearch: (q: string) => handleSearch(q, name),
    placeholder,
    onKeyPress: onSearchEnterPress(name),
    className,
    clearable,
  },
});

const getResetButton = ({disabled}): FiltersBarItem => ({
  type: 'button',
  name: 'reset',
  props: {
    children: 'Reset',
    className: 'Orders__reset-button',
    disabled,
    onClick: () => browserHistory.deleteParameter(ORDERS_URL_PARAMS.SEARCH),
  },
});

export const getFiltersFields = ({q}) => {
  const searchField = getSearchField({
    name: ORDERS_URL_PARAMS.SEARCH,
    placeholder:
      'Search orders by PO Number, Invoice Number, Ship To Account Number, or ISBN10/ISBN13',
    className: 'Orders__field-search',
    customKey: String(!!q),
  });

  const resetButton = getResetButton({
    disabled: !q?.trim().length,
  });

  return [searchField, resetButton];
};
